import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EntityViewModal = ({ isOpen, onClose, item, entityType, config, language, onEdit, onDelete }) => {
  if (!isOpen || !item) return null;

  const labels = {
    title: { en: `${config?.labels?.singular?.en} Details`, ar: `تفاصيل ${config?.labels?.singular?.ar}` },
    edit: { en: 'Edit', ar: 'تعديل' },
    delete: { en: 'Delete', ar: 'حذف' },
    close: { en: 'Close', ar: 'إغلاق' }
  };

  const getNestedValue = (obj, path) => {
    return path?.split('.')?.reduce((acc, part) => acc?.[part], obj);
  };

  const renderFieldValue = (field) => {
    const value = field?.key?.includes('.')
      ? getNestedValue(item, field?.key)
      : item?.[field?.key];

    if (field?.type === 'file' && Array.isArray(value)) {
      return (
        <div className="grid grid-cols-3 gap-2 mt-2">
          {value?.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`${field?.label?.[language]} ${index + 1}`}
              className="w-full h-24 object-cover rounded-lg border border-border"
            />
          ))}
        </div>
      );
    }

    if (field?.type === 'multiselect' && Array.isArray(value)) {
      return (
        <div className="flex flex-wrap gap-2 mt-2">
          {value?.map((v, i) => (
            <span key={i} className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-primary/10 text-primary">
              {v}
            </span>
          ))}
        </div>
      );
    }

    if (field?.type === 'number' && field?.key === 'price') {
      return <span className="text-base font-semibold text-success">${parseFloat(value)?.toFixed(2)}</span>;
    }

    if (field?.type === 'textarea') {
      return <p className="text-base text-foreground mt-1 whitespace-pre-wrap">{value}</p>;
    }

    return <p className="text-base font-medium text-foreground mt-1">{value}</p>;
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-elevation-4 border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="border-b border-border px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-foreground">
            {labels?.title?.[language]}
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-smooth"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-4">
          {config?.formFields?.map((field) => (
            <div key={field?.key}>
              <label className="text-sm font-medium text-text-secondary">{field?.label?.[language]}</label>
              {renderFieldValue(field)}
            </div>
          ))}

          <div className="flex gap-3 pt-4">
            <Button
              variant="outline"
              fullWidth
              onClick={onEdit}
              iconName="Edit2"
            >
              {labels?.edit?.[language]}
            </Button>
            <Button
              variant="destructive"
              fullWidth
              onClick={onDelete}
              iconName="Trash2"
            >
              {labels?.delete?.[language]}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EntityViewModal;